import {
  boolean,
  route,
  string,
  type
} from "seneca-common/utils/routing/react-router-typesafe-routes/dom";

import { TeacherPlatformGatingEventRoutingType } from "features/teachers/features/gating/types";

import {
  anyValidator,
  classAndAssignmentArrayType,
  locationType,
  toValidator
} from "./types";

export const ROUTES = {
  DASHBOARD: route(
    "dashboard",
    {},
    {
      CLASSES: route(
        "classes",
        {},
        {
          ASSIGNMENTS: route(
            "assignments",
            {},
            {
              UPCOMING: route("upcoming"),
              PAST: route("past")
            }
          )
        }
      )
    }
  ),
  TEACHER: route(
    "teacher",
    { state: { teacherBackground: locationType } },
    {
      SETTINGS: route(
        "settings",
        { state: { settingsBackground: locationType } },
        {
          PERSONAL_INFORMATION: route(
            "personal-information",
            {},
            { CHANGE_EMAIL: route("change-email") }
          ),
          PASSWORD: route("password"),
          NOTIFICATIONS: route("notifications")
        }
      ),
      CLASS: route(
        "class/:classId",
        {
          params: { classId: string().default("") }
        },
        {
          ASSIGNMENTS: route(
            "assignments",
            {},
            {
              OVERVIEW: route("overview"),
              ASSIGNMENT: route("assignment/:assignmentId", {
                params: { assignmentId: string().default("") }
              })
            }
          )
        }
      ),
      MIS_EXPIRY: route("mis-expiry", {
        state: {
          gatingEvent: TeacherPlatformGatingEventRoutingType
        }
      })
    }
  ),
  DIAGNOSIS: route("diagnosis", {
    state: {
      noUpdateRedirect: boolean()
    }
  }),
  UPDATE: route("update", {
    state: {
      redirectPostUpdate: type(toValidator),
      redirectState: type(anyValidator)
    }
  })
};

export const MODAL_ROUTES = route(
  "",
  { state: { background: locationType } },
  {
    UNLOCK_DARK_MODE: route("unlock-dark-mode"),
    SHARE_ASSIGNMENT: route("share-assignment", {
      searchParams: {
        classId: string().default(""),
        assignmentId: string().default("")
      }
    }),
    SHARE_ASSIGNMENTS: route("share-assignments", {
      state: {
        multipleAssignments: classAndAssignmentArrayType
      }
    }),
    MANAGE_STUDENT: route("manage-student", {
      searchParams: {
        classId: string().default(""),
        userId: string().default("")
      },
      state: { source: string().default("") }
    }),
    ASSIGNMENT_STUDENT_RESULT: route("student-assignment-result", {
      searchParams: {
        classId: string().default(""),
        assignmentId: string().default(""),
        userId: string().default("")
      },
      state: {
        orderedAssigneeIds: string().default("").array()
      }
    }),
    DELETE_ASSIGNMENT: route("delete-assignment", {
      searchParams: {
        classId: string().default(""),
        assignmentId: string().default("")
      }
    }),
    START_SPEEDY_MARKING: route("start-speedy-marking", {
      searchParams: {
        classId: string().default(""),
        assignmentId: string().default("")
      },
      state: {
        selectedQuestionIds: string().default("").array()
      }
    }),
    MARKING: route("marking", {
      searchParams: {
        classId: string().default(""),
        assignmentId: string().default(""),
        userId: string().default(""),
        questionId: string().default("")
      },
      state: {
        orderedAssigneeIds: string().default("").array()
      }
    })
  }
);
